"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getAuthStateKeysFromAll = exports.getAuthStateKeysFromCookies = exports.getAuthStateKeysFromLocalStorage = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _clientStorage = require("../clientStorage");

var _isStringAuthStateKey = _interopRequireDefault(require("./isStringAuthStateKey"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * get an array containing all of the auth state keys found in local storage
 */


var getAuthStateKeysFromLocalStorage = function getAuthStateKeysFromLocalStorage() {
  var stateKeys = _lodash.default.reduce(Object.keys(window.localStorage), function (accumulator, key) {
    return (0, _isStringAuthStateKey.default)(key) // if its an auth state key add it to accumulator
    ? [].concat(_toConsumableArray(accumulator), [key]) // else return accumulator
    : accumulator;
  }, []);

  return stateKeys;
};
/**
 * get an array containing all of the auth state keys found in cookies
 */


exports.getAuthStateKeysFromLocalStorage = getAuthStateKeysFromLocalStorage;

var getAuthStateKeysFromCookies = function getAuthStateKeysFromCookies() {
  var allCookies = document.cookie.split(/; */);

  var stateKeys = _lodash.default.reduce(allCookies, function (accumulator, cookieString) {
    var _cookieString$split = cookieString.split('='),
        _cookieString$split2 = _slicedToArray(_cookieString$split, 1),
        name = _cookieString$split2[0];

    return (0, _isStringAuthStateKey.default)(name) ? [].concat(_toConsumableArray(accumulator), [name]) : accumulator;
  }, []);

  return stateKeys;
};
/**
 * Check all supported storage types for auth state keys
 */


exports.getAuthStateKeysFromCookies = getAuthStateKeysFromCookies;

var getAuthStateKeysFromAll = function getAuthStateKeysFromAll() {
  var authStateKeys = [].concat(_toConsumableArray(getAuthStateKeysFromLocalStorage()), _toConsumableArray(getAuthStateKeysFromCookies()));
  return authStateKeys;
};
/**
 *
 * @param {*} clientStorageType
 */


exports.getAuthStateKeysFromAll = getAuthStateKeysFromAll;

var getAuthStateKeys = function getAuthStateKeys(clientStorageType) {
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return getAuthStateKeysFromCookies();

    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return getAuthStateKeysFromLocalStorage();

    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return getAuthStateKeysFromAll();
  }
};

var _default = getAuthStateKeys;
exports.default = _default;